module.exports = __webpack_public_path__ + "img/button-left-indicators.edce1f75.png";